import { frontPlayer, prevPlayer, getTopCard, findWinner } from "./table.js";
//importing table datas, 
//the player in front of the actual player
//prevplayer: the player that has played just before the user
//gettopcard: le carte gagnat sur table a l'etat actuel
//findwinner: qui est le gagnant 

export let playAi = (
  hand,
  { totalCardsInTable, firstCardPlayed, firstPlayer, cards },
  trump,
  player
) => {
  /*
  console.log(
    "I am in AI calculation of the " +
      player +
      " with hand " +
      JSON.stringify(hand)
  );
  console.log(cards);
  */

  //choisir au hasard un carte a jouer
  let index = Math.floor(Math.random() * hand.length);

  let hasSuit = Object.values(hand).some(
    (e) => e?.suit === firstCardPlayed?.suit
  );
  let hasTrump = Object.values(hand).some((e) => e?.suit === trump);
  //let trumpOpenPlay = firstCardPlayed?.suit === trump;
  let trumpPlayed = Object.values(cards).some((e) => e?.suit === trump);

  switch (totalCardsInTable) {
    case 3:
      let theActualWinner = findWinner(
        trump,
        firstCardPlayed?.suit,
        cards
      ).winner;

      if (theActualWinner === frontPlayer(player)) {
        // console.log("the actual winner is my partner");
        //if your team is winning
        if (hasSuit) {
          //i have response
          // but since my parter is winning i play a small card to avoid wining
          index = getLowSuitCard(hand, firstCardPlayed?.suit);
          // console.log("so i am playing the highest card  : " + hand[index].alt);
        } else {
          //i dont have trump, I am playing a high value card
          index = getHighPointsCard(hand, trump);
          // console.log(
          //   "i dont have the suit so i am playing the highest point card  : " +
          //     hand[index].alt
          // );
        }
      } else {
        //if the ennemie team is winning
        // console.log("the actual winner is our ennemies");

        if (hasSuit) {
          // if i have the suit
          if (!trumpPlayed) {
            // no trump has been played, so i can try to beat them

            let myTop = getHighSuitCard(hand, firstCardPlayed?.suit);

            if (hand[myTop].rank === getTopCard(firstCardPlayed?.suit)) {
              //if i have the top card i play
              index = myTop;
              // console.log(
              //   "so i am playing the highest card to win the game : " +
              //     hand[index].alt
              // );
            } else {
              //if not i play a low card
              index = getLowSuitCard(hand, firstCardPlayed?.suit);
              // console.log("i have only weak cards : " + hand[index].alt);
            }
          } else {
            // if trump has been played, i throw a low suit card
            index = getLowSuitCard(hand, firstCardPlayed?.suit);
            // console.log("i have only weak cards : " + hand[index].alt);
          }
        } else if (hasTrump) {
          //if i dont have suit but i have trump card
          if (!trumpPlayed) {
            //if no trump card has been played, i play the high trump card
            index = getHighSuitCard(hand, trump);
            // console.log(
            //   "i have a trump card i am playing it to win : " + hand[index].alt
            // );
          } else {
            //some enemie player played trump card
            let myTopTrump = getHighSuitCard(hand, trump);
            if (cards[theActualWinner].points < hand[myTopTrump].points) {
              index = myTopTrump;
              // console.log(
              //   "i have a better trump card  than what is played : " +
              //     hand[index].alt
              // );
            } else {
              index = getLowPointsCard(hand, trump);
              // console.log(
              //   "my trump cards are week, so i am playing a low points card : " +
              //     hand[index].alt
              // );
            }
          }
        } else {
          //if have neither suit neith trump
          //i check if i have a top card that i can show my dude
          let lowOfTop = getLowOfTopCardInHand(hand,trump);
          if (lowOfTop !== 0 && player === "north") {
            //if yes, i send the message, only for partner not for ai
            index = lowOfTop;
            // console.log(
            //   "I have neither suit nor trump, i am north so i am playing a support card: " +
            //     hand[index].alt
            // );
          } else {
            //if no i throw a valuable card
            index = getLowPointsCard(hand, trump);
            // console.log(
            //   "I have neither suit nor trump,i am playing a low points card: " +
            //     hand[index].alt
            // );
          }
        }
      }
      break;
    case 2:
      //i check if my partners card has been cut
      if (
        firstCardPlayed?.suit !== trump &&
        cards[prevPlayer(player)].suit === trump
      ) {
        // console.log("My partners card has been cut");

        if (hasSuit) {
          //if yes i play a low card in the same suit
          index = getLowSuitCard(hand, firstCardPlayed?.suit);
          // console.log("so i am playing the lowest card  : " + hand[index].alt);
        } else if (hasTrump) {
          //i dont have answer but i have trump,
          let myTopTrump = getHighSuitCard(hand, trump);
          if (hand[myTopTrump].points > cards[prevPlayer(player)].points) {
            //I check if my trump is powerfull than the previos played trump card
            index = myTopTrump;
            //  console.log(
            //   "but i can go heigher than him with  : " + hand[index].alt
            // );
          } else {
            //if not i play a low card
            index = getLowPointsCard(hand, trump);

            // console.log(
            //   "I have only week trumps, so i am playing a low points card  : " +
            //     hand[index].alt
            // );
          }
        } else {
          //i dont have trump, I am playing a low value card ( improuvable)
          index = getLowPointsCard(hand, trump);
          // console.log(
          //   "I dont have suite neither trump,  so i am playing a low points card  : " +
          //     hand[index].alt
          // );
        }
      } else {
        //my parner was not cut
        // console.log("My partners card has not been cut");
        if (
          cards[frontPlayer(player)].rank === getTopCard(firstCardPlayed?.suit)
        ) {
          // console.log("and he has played the top card");
          //he has played the top card
          if (hasSuit) {
            //i have response, i send the high card i have in the same suit ( improuvable)
            if(firstCardPlayed?.suit !== trump){
              //if my partner has not played trump then put a high value card
              index = getHighSuitCard(hand, firstCardPlayed?.suit);
            }else{
              //if partner has played a trump card
              index = getLowSuitCard(hand, firstCardPlayed?.suit);
            }
           
            // console.log("I play the toppest card i have : " + hand[index].alt);
            
          } else {
            let lowOfTop = getLowOfTopCardInHand(hand,trump);

            if (lowOfTop !== 0 && player === "north") {
              //if yes, i send the message, only for partner not for ai
              index = lowOfTop;
              // console.log(
              //   "I have neither suit nor trump, i am north so i am playing a support card: " +
              //     hand[index].alt
              // );
            } else {
              //i dont have trump, I am playing a high value card ( improuvable)
              index = getHighPointsCard(hand, trump);
              // console.log(
              //   "I have neither suit nor trump, I am playing a high value card : " +
              //     hand[index].alt
              // );
            }
          }
        } else {
          //he has played a low card
          // console.log("and he has played a low card");
          if (hasSuit) {
            //i have response, i check if my high card is  over the initial played card
            let myTop = getHighSuitCard(hand, firstCardPlayed?.suit);
            if (hand[myTop].rank === getTopCard(firstCardPlayed?.suit)) {
              //if yes i play that
              index = myTop;
              // console.log(
              //   "I have the top card, i am playing it : " + hand[index].alt
              // );
            } else {
              //if not i play a low card
              index = getLowSuitCard(hand, firstCardPlayed?.suit);
              // console.log(
              //   "I dont have the top card, i am playing a low card : " +
              //     hand[index].alt
              // );
            }
          } else if (hasTrump) {
            //i dont have answer but i have trump, then i play it ( improuvable )
            index = getLowSuitCard(hand, trump);
            // console.log(
            //   "I dont have the suit but i have trump, i am playing a low trump : " +
            //     hand[index].alt
            // );
          } else {
            //i dont have trump, I am playing a low value card ( improuvable)
            index = getLowPointsCard(hand, trump);
            // console.log(
            //   "I dont have the suit nor the trump, i am playing a low points card : " +
            //     hand[index].alt
            // );
          }
        }
      }

      break;
    case 1:
      if (hasSuit) {
        //i have response, i check if my high card is  over the initial played card
        let myTop = getHighSuitCard(hand, firstCardPlayed?.suit);

        if (hand[myTop].rank === getTopCard(firstCardPlayed?.suit)) {
          //if yes i play that
          index = myTop;

          // console.log(
          //   "I have the topest card, i am playing it" + hand[index].alt
          // );
        } else {
          //if not i play a low card
          index = getLowSuitCard(hand, firstCardPlayed?.suit);

          // console.log(
          //   "I dont have the top card I am playing the low card" +
          //     hand[index].alt
          // );
        }
      } else if (hasTrump) {
        //i dont have answer but i have trump, then i play it ( improuvable )

        index = getHighSuitCard(hand, trump);

        // console.log(
        //   "I dont have the suit, but i have the trump, i am playing the top trump card i have" +
        //     hand[index].alt
        // );
      } else {
        //i dont have trump, I am playing a low value card ( improuvable)

        index = getLowPointsCard(hand, trump);

        // console.log(
        //   "I have neither suit cards no trump, i am playing a low point card" +
        //     hand[index].alt
        // );
      }

      break;
    case 0:
      // if i start the game
      // console.log("I have to start the game");
      let myTop = getMyTopCard(hand, trump);
      let playedcard = getPlayedCard(hand, trump);
      let unplayedCard = getUnPlayedCard(hand, trump);
      let lowPointsCard = getLowPointsCard(hand, trump);
      if (myTop < 8) {
        //i check if i have a top card, if yes i play
        index = myTop;
        //console.log("I have a top card, i am playing :" + hand[index].alt);
      } else {
        if (playedcard < 8 && player === "north") {
          index = +playedcard;
/*
          console.log(
            "I am partner, i play a already played suit or a trump suit" +
              hand[index].alt
          );
          */
        } else if (unplayedCard < 8 && player !== "north") {
          index = +unplayedCard;
          //console.log("I am enemie, i play a new suit: " + hand[index].alt);
        } else if (lowPointsCard < 8) {
          index = +lowPointsCard;
          /*
          console.log(
            "I dont have a top card, i am playing low card :" + hand[index].alt
          );
          */
        } else {
          console.log("I through a random card :" + hand[index].alt);
        }
      }
      break;
    default:
      alert("total cards in table not valid");
  }

  return +index;
};

let getMyTopCard = (hand, trump) => {
  let index = 10;
  for (let i in hand) {
    if (
      hand[i]?.rank === getTopCard(hand[i]?.suit) &&
      hand[i]?.suit !== trump
    ) {
      index = +i;
      break;
    }
  }
  return +index;
};

let getPlayedCard = (hand, trump) => {
  let index = 10;
  for (let i in hand) {
    // i check if i have a played suit card ( if the top card of the suit is not jack )
    if (getTopCard(hand[i]?.suit) !== "jack" && hand[i]?.suit !== trump) {
      return +i;
    }
  }

  return +index;
};

let getUnPlayedCard = (hand, trump) => {
  let index = 10;
  for (let i in hand) {
    // i check if i have a unplayed suit card ( if the top card of the suit is jack )
    if (
      getTopCard(hand[i]?.suit) === "jack" &&
      hand[i]?.suit !== trump &&
      hand[i]?.rank !== "nine"
    ) {
      return +i;
    }
  }

  return +index;
};

let getHighSuitCard = (hand, suit) => {
  let index = 0;
  for (let i in hand) {
    if (hand[i]?.suit === suit && hand[i]?.rank !== "nine") {
      return +i;
    }
    if (hand[i]?.suit === suit) {
      index = +i;
    }
  }
  return +index;
};

let getLowSuitCard = (hand, suit) => {
  let index = 0;
  for (let i in hand) {
    if (hand[i]?.suit === suit) {
      index = +i;
    }
  }
  return +index;
};

let getLowOfTopCardInHand = (hand,trump) => {
  //the initial card is the 1st card
  let index = 0;
  //we go through each card in hand
  for (let i in hand) {
    //we check if we have the top card for any sign other than trump
    if (hand[i]?.rank === getTopCard(hand[i]?.suit) && hand[i]?.suit !== trump ) {
      let j = +i + 1;
      //if we do then we go through the cards to find the lowest, this is to show the partner that we have the top card in this sign 
      while (hand[j]?.suit === hand[i]?.suit) {
        index = j;
        j++;
      }
      //if we have found a low of top card then exit
      if (index !== 0) {
        break;
      }
    }
  }
  return +index;
};

let getHighPointsCard = (hand, trump) => {
  let index = 0;
  let points = -1;
  for (let i in hand) {
    if (
      hand[i]?.points > points &&
      hand[i]?.suit !== trump &&
      hand[i]?.rank !== getTopCard(hand[i]?.suit)
    ) {
      points = hand[i]?.points;
      index = +i;
    }
  }
  return +index;
};

let getLowPointsCard = (hand, trump) => {
  let index = 0;
  let points = 31;
  for (let i in hand) {
    if (
      hand[i]?.points < points &&
      hand[i]?.suit !== trump &&
      hand[i]?.rank !== getTopCard(hand[i]?.suit)
    ) {
      points = hand[i]?.points;
      index = +i;
    }
  }
  return +index;
};

// we will make the ai choose a bet according to its hand of cards
export let checkBet = (hand) => {
  //the function will return the choosed card, its sign and the amount of bet

  //console.log(hand);
  // the bet object that we wil return
  const theBet = {
    index: 0,
    suit: "",
    amount: 0,
  };

  let prevSuit = "";
  let suitCount = 0;

  //lets check if the hand has the same suit more than 3 times, if yes it bets
  for (let i in hand) {
    if (suitCount > 5) {
      theBet.index = i - 1;
      theBet.suit = prevSuit;
      theBet.amount = 250;

      break;
    }
    if (suitCount > 4) {
      theBet.index = i - 1;
      theBet.suit = prevSuit;
      theBet.amount = 210;

      break;
    }
    if (suitCount > 3) {
      theBet.index = i - 1;
      theBet.suit = prevSuit;
      theBet.amount = 190;

      break;
    }

    if (suitCount > 2) {
      theBet.index = i - 1;
      theBet.suit = prevSuit;
      theBet.amount = 170;

      break;
    }

    if (prevSuit === "") {
      prevSuit = hand[i].suit;
      suitCount++;
    } else {
      if (prevSuit === hand[i].suit) {
        suitCount++;
      } else {
        prevSuit = hand[i].suit;

        suitCount = 1;
      }
    }
  }

  return theBet;
};


